'use client';
import { useEffect } from 'react';
import { Tab } from '@/components/ui';
import { IconHome, IconReviewStars } from '@repo/svgs';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { useAnalytics } from '@/hooks/useAnalytics';
import { cn } from '@/lib/cn';

interface TabNavigationProps {
  /** Stretch the tabs to an exact 50/50 split of the available width, with no gap. */
  fullWidth?: boolean;
}

export function TabNavigation({ fullWidth = false }: TabNavigationProps) {
  const pathname = usePathname();
  const router = useRouter();
  const analytics = useAnalytics();
  const isReviews = pathname === '/read-reviews';

  useEffect(() => {
    // Prefetch both directions on mount
    router.prefetch('/');
    router.prefetch('/read-reviews');
  }, [router]);

  // basis-0 + flex-1 gives each link exactly half the row regardless of label length.
  const linkClassName = fullWidth ? 'block min-w-0 flex-1 basis-0' : undefined;
  const tabClassName = fullWidth ? 'w-full' : undefined;

  return (
    <div className={cn('flex items-center justify-center', fullWidth ? 'w-full gap-0' : 'gap-x-4')}>
      <Link
        href="/"
        className={linkClassName}
        onPointerEnter={() => router.prefetch('/')}
        onClick={() => analytics.track('header_explore_listings')}
      >
        <Tab
          background="secondary"
          active={!isReviews}
          icon={<IconHome />}
          className={tabClassName}
        >
          Rent apartments
        </Tab>
      </Link>
      <Link
        href="/read-reviews"
        className={linkClassName}
        onPointerEnter={() => router.prefetch('/read-reviews')}
        onClick={() => analytics.track('header_read_review')}
      >
        <Tab
          background="secondary"
          active={isReviews}
          icon={<IconReviewStars />}
          className={tabClassName}
        >
          Read reviews
        </Tab>
      </Link>
    </div>
  );
}
